import getAppRoot from '../../../utils/getAppRoot';
import { SmsAddonFailedDtoModelType } from '../../../models';

export default ({ store, requestUuid, reason }: SmsAddonFailedDtoModelType) => {
  const rootStore = getAppRoot(store);
  rootStore.billing.onSmsAddonFailed(requestUuid ?? '', reason ?? null);
};
